
import { Tooltip, } from 'react-tooltip'
import H3 from '../provider/h3/H3.jsx';

const BoxInfo = (
    {
        id,
        title,
        content = "",
        openOnClick = true,
        place,
        styles = {},
        titleStyle = {},
        titleClass = "",
        containerClass = "",
        render
    }
) => {


    return (

        <div className={`${containerClass} flex items-center`} style={styles}   >
            {/*<span style={titleStyle} className={titleClass} >{title}</span>*/}
            <H3 text={title} style={titleStyle} className={titleClass} />
            <img id={id} src="/icons/tooltip-indicator-icon.svg" className="cursor-pointer tooltip-nesting" style={{margin: 5}} alt="" />
            <Tooltip openOnClick={openOnClick} className='z-100' anchorSelect={`#${id}`} content={content} place={place} html={render} />
        </div>
    )

}

export default BoxInfo;